export default __webpack_public_path__ + "static/media/lp-02-pricing-desktop.c452dfa6.jpg";